/* The slim buy bar on desktop (sections/almila-buy-bar.liquid, 15 Oct 2026) and the buy button on phones (23 Oct 2026;
   maintenance/almila-buy-bar.md). It owns no cart logic: its button presses the page's own buy button, so the form's
   submit (assets/app.js) runs with that button as the submitter and the add-ons block (assets/almila-product-addons.js)
   adds the ticked add-ons and the chosen quantity exactly as from the page. It follows that button's words, its disabled
   state (sold out, adding) and the page's price.
   - From 992px it shows while that button is out of the window and lines its button up with it. A press also brings
     the purchase box into view, so the add-ons' messages and the theme's notices next to the form are seen (the
     release review of 14 Oct).
   - Below 768px it shows once that button has scrolled above the window, and not while the cookie notice is open. A
     press keeps the visitor where they are and the button says „Добавено“ for a moment once the cart count rises; if it
     does not rise, the purchase box comes into view, where the theme and the add-ons say why. On a product with a
     choice (an option with more than one value), until the visitor touches it on this page or arrives on a chosen
     variant (?variant=), the button reads „Изберете вариант“ and takes them to the options instead of adding the first
     variant, which Erickson preselects.
   If the theme renames what it reads, the bar stays hidden. */
(() => {
  const bar = document.querySelector('[data-almila-buy-bar]');
  const form = document.querySelector('[data-section-type="product"] form.add-to-cart-form');
  const main = form && form.querySelector('button.add-to-cart-button[name="add"]');
  if (!bar || !main) return;
  // Fixed to the window: out of the section wrapper, so no ancestor can become its containing block. In the theme editor
  // it stays in its section, so re-rendering or removing the section takes it along (the wrapper has no transform).
  const editor = !!(window.Shopify && window.Shopify.designMode);
  if (!editor) document.body.appendChild(bar);
  const root = document.documentElement;
  const $ = (selector) => bar.querySelector(selector);
  const button = $('.almila-buy-bar__button');
  const label = $('.almila-buy-bar__label');
  const buttonPrice = $('.almila-buy-bar__button-price');
  const status = $('[data-almila-buy-bar-status]');
  const watch = main.closest('.add-to-cart__wrapper') || main;
  const lessMotion = matchMedia('(prefers-reduced-motion: reduce)');
  const desktop = matchMedia('(min-width: 992px)');
  const phone = matchMedia('(max-width: 767.98px)');
  const scrollTo = (el) => el.scrollIntoView({ block: 'center', behavior: lessMotion.matches ? 'auto' : 'smooth' });

  // Phones: the options a visitor has to look at (Erickson's selects, one per option, shown by assets/slim-select.js as
  // a combobox beside the hidden select; 6 of 524 products on 23 Oct). A tap, a key or a change in that area counts.
  const choices = [...form.querySelectorAll('select[name^="option"]')].filter((select) => select.options.length > 1);
  const areaOf = (select) => select.closest('.styled-select') || select.parentElement;
  let chosen = !choices.length || new URLSearchParams(location.search).has('variant');
  const choose = () => { if (!chosen) { chosen = true; sync(); } };
  choices.forEach((select) => ['pointerdown', 'keydown', 'change'].forEach((type) => areaOf(select).addEventListener(type, choose)));

  // Phones: the add worked when the header's cart count rises (app.js writes the new count after the cart refresh).
  const counter = document.querySelector('.js-cart-item-count');
  const count = () => parseInt(counter.textContent, 10) || 0;
  let added = false;
  let addedTimer = 0;
  let waitTimer = 0;
  let waiting = null;
  const stopWaiting = () => { if (waiting) waiting.disconnect(); waiting = null; clearTimeout(waitTimer); };
  const awaitAdd = () => {
    stopWaiting();
    if (!counter) return;
    const before = count();
    waiting = new MutationObserver(() => {
      if (count() <= before) return;
      stopWaiting();
      added = true;
      status.textContent = bar.dataset.addedStatus;
      sync();
      clearTimeout(addedTimer);
      addedTimer = setTimeout(() => { added = false; status.textContent = ''; sync(); }, 1600);
    });
    waiting.observe(counter, { childList: true, characterData: true, subtree: true });
    waitTimer = setTimeout(() => { stopWaiting(); main.focus({ preventScroll: true }); scrollTo(main); }, 10000);
  };

  button.addEventListener('click', () => {
    if (phone.matches && !chosen) {
      const area = areaOf(choices[0]);
      scrollTo(area);
      (area.querySelector('[role="combobox"][tabindex="0"]') || choices[0]).focus({ preventScroll: true });
      return;
    }
    if (main.disabled || added) return;
    if (phone.matches) {
      awaitAdd();
      main.click();
      return;
    }
    main.click();
    // Focus follows to the page's own button (a keyboard press must not drop to the page body), in view.
    main.focus({ preventScroll: true });
    scrollTo(main);
  });

  // The price is what the button adds: with add-ons ticked the add-ons panel's total, with more than one piece
  // „2 × price“, else the page's price with its old price (the release review of 15 Oct). The phone button shows the
  // same without the old price.
  const totals = document.querySelector('[data-addons-totals]');
  const quantity = form.querySelector('input[name="quantity"]');
  const text = (el) => (el ? el.textContent.replace(/\s+/g, ' ').trim() : '');
  const sync = () => {
    const now = form.querySelector('#pdp-prices .js-price');
    const was = form.querySelector('#pdp-prices .js-price-compare');
    const total = totals && !totals.hidden ? text(totals.querySelector('[data-addons-total]')) : '';
    const pieces = quantity ? parseInt(quantity.value, 10) || 1 : 1;
    const sale = !!(was && was.style.display !== 'none' && was.textContent.trim());
    const price = total || (pieces > 1 ? `${pieces} × ${text(now)}` : text(now));
    $('.almila-buy-bar__now').textContent = price;
    $('.almila-buy-bar__was').textContent = sale && !total && pieces === 1 ? text(was) : '';
    $('.almila-buy-bar__price').classList.toggle('is-sale', sale && !total);
    const choosing = phone.matches && !chosen;
    // While the theme's button shows its spinner it has no words; the bar keeps the last ones.
    const words = main.textContent.replace(/\s+/g, ' ').trim() || label.textContent;
    label.textContent = added ? bar.dataset.added : choosing ? bar.dataset.choose : words;
    buttonPrice.textContent = added || choosing || main.disabled ? '' : price;
    button.classList.toggle('is-added', added);
    button.disabled = main.disabled && !choosing;
    fit();
  };

  // Phones: when the words and the price do not fit one line inside the button's padding, the price goes under the
  // words. (Centred flex content spills into the padding on both sides before scrollWidth notices, so the parts are
  // measured against the padding.)
  const fit = () => {
    button.classList.remove('is-tight');
    if (!phone.matches || !buttonPrice.textContent) return;
    const box = button.getBoundingClientRect();
    const pad = parseFloat(getComputedStyle(button).paddingLeft) || 0;
    if (label.getBoundingClientRect().left < box.left + pad - 0.5 || buttonPrice.getBoundingClientRect().right > box.right - pad + 0.5) button.classList.add('is-tight');
  };

  // The bar's content starts where the photo column starts and its button ends, at the same width, where the page's
  // button ends.
  const place = () => {
    const r = main.getBoundingClientRect();
    const photo = document.querySelector('#product-form .slideshow-wrap') || form;
    const left = photo.getBoundingClientRect().left + parseFloat(getComputedStyle(photo).paddingLeft || 0);
    bar.style.setProperty('--almila-buy-bar-left', `${Math.max(16, Math.round(left))}px`);
    bar.style.setProperty('--almila-buy-bar-right', `${Math.max(16, Math.round(root.clientWidth - r.right))}px`);
    bar.style.setProperty('--almila-buy-bar-button', `${Math.round(r.width)}px`);
  };

  let out = false;
  let above = false;
  let gone = false;
  const cookieOpen = () => root.classList.contains('almila-cookie-notice-open');
  const show = () => {
    const on = !gone && ((desktop.matches && out) || (phone.matches && above && !cookieOpen()));
    if (on && desktop.matches) place();
    bar.hidden = !on;
    root.classList.toggle('almila-buy-bar-open', on);
    if (on && phone.matches) {
      root.style.setProperty('--almila-buy-bar-phone-height', `${bar.offsetHeight}px`);
      fit();
    } else root.style.removeProperty('--almila-buy-bar-phone-height');
  };

  sync();
  new MutationObserver(sync).observe(form.querySelector('#pdp-prices') || form, { subtree: true, childList: true, characterData: true, attributes: true });
  if (totals) new MutationObserver(sync).observe(totals, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['hidden'] });
  if (quantity) { quantity.addEventListener('input', sync); quantity.addEventListener('change', sync); form.addEventListener('click', () => setTimeout(sync, 0)); }
  // Theme editor: when the section is re-rendered or removed this bar is gone; the page stops making room for it.
  if (editor) document.addEventListener('shopify:section:unload', (event) => { if (event.target.contains(bar)) { gone = true; show(); } });
  new MutationObserver(sync).observe(main, { subtree: true, childList: true, characterData: true, attributes: true, attributeFilter: ['disabled'] });
  new IntersectionObserver(([entry]) => {
    out = entry.intersectionRatio < 0.99;
    above = !entry.isIntersecting && entry.boundingClientRect.bottom <= 0;
    show();
  }, { threshold: [0, 0.99, 1] }).observe(watch);
  // Phones: the cookie notice (assets/almila-cookie-notice.js marks <html> while it shows) has the bottom to itself.
  let notice = cookieOpen();
  new MutationObserver(() => { if (cookieOpen() !== notice) { notice = cookieOpen(); show(); } }).observe(root, { attributes: true, attributeFilter: ['class'] });
  desktop.addEventListener('change', show);
  phone.addEventListener('change', () => { sync(); show(); });
  addEventListener('resize', () => { if (!bar.hidden) { if (desktop.matches) place(); else fit(); } }, { passive: true });
})();
